import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    selectL:'',
    notiId:0,
    idContenido: 0,
    rutaApi:'https://admin-narradores.adaptaclima.org/',
    bVerInundacion: false,
    bVerDeliz:false,
    mostrarmenu: false,
  },
})
